import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';
import {motion} from "framer-motion";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { getLocalizedText } from '../utils/textLocalization';

function App() {
  const dealerLoadingTitle = getLocalizedText('dealers.loadingtitle');
  const dealerLoadingText = getLocalizedText('dealers.loadingtext');

  return (
    <>
      <motion.div key="loading" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
        <div className="prodejce-container">
          <div className="Map-Loading">
            <AiOutlineLoading3Quarters />
            <h3>{dealerLoadingTitle}</h3>
            <h4>{dealerLoadingText}</h4>
          </div>
          

          <div className="prodejci-menu">
            <input placeholder="Najít prodejce" type="text"/>
            <div className="prodejce-box-loading" />
            <div className="prodejce-box-loading" />
            <div className="prodejce-box-loading" />
            <div className="prodejce-box-loading" />
          </div>
          </div>
      </motion.div>
    </>
  );
}

export default App;
